export default __webpack_public_path__ + "static/balsamiq-47c11930abf50d9bdc94ea7ae4a060e4.png";